<template>
  <div class="wrapper" id="partners-page">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>
    <div id="main-panel2" class="main main-raised" ref="page">
      <div class="cd-section section section-basic">
        <div class="md-layout">
          <div class="md-layout-item md-size-65 md-small-size-85 mx-auto md-alignment-top-center">
            <h2
              class="black text-center text-primary"
              style="margin:0px 0px 40px 0px"
            >{{$t('Partners')}}</h2>

            <partners-list :showAll="true" :showFilters="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";

import PageHeader from "./layout/PageHeader";
import PartnersList from "./components/Partners/PartnersList";

export default {
  components: { PageHeader, PartnersList },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",

  data() {
    return {
      image: require("@/assets/img/conference/landing-bg-new.png") // header img
    };
  }
};
</script>

<style lang="scss">
#partners-page {
  .md-field.md-form-group::after,
  .md-field.md-form-group::before,
  .md-field.md-datepicker::after,
  .md-field.md-datepicker::before {
    width: 100%;
  }
  .md-field.md-form-group + .md-error {
    margin-left: 0px;
  }
}
</style>